import React, { ReactNode } from "react";
import { SerializedStyles, css } from '@emotion/react';

import { mediaQueries, pxToRem } from "../styles/css-utils";

type GridContainerProps = {
  children: ReactNode,
  rowGap?: Boolean,
  css?: SerializedStyles | SerializedStyles[],
  id?: string
};

const GridContainer = ({ children, rowGap, ...props } : GridContainerProps) : JSX.Element => {
  const containerStyles = css`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    row-gap: ${rowGap ? pxToRem(24) : '0'};
    margin-left: auto;
    margin-right: auto;

    //0-767px
    width: calc(100% - ${pxToRem(40)});
    column-gap: ${pxToRem(20)};

    //768px - 1279px
    ${mediaQueries.md} {
      width: calc(100% - ${pxToRem(64)});
    }

    //1280px - 1439px
    ${mediaQueries.xl} {
      column-gap: ${pxToRem(40)};
    }

    //1440-1599px
    ${mediaQueries.xxl} {
      width: calc(100% - ${pxToRem(80)})
    }

    //1600+ px
    ${mediaQueries.xxxl} {
      max-width: ${pxToRem(1520)};
    }
  `;
  
  return (
    <div {...props} css={containerStyles} >
      { children }
    </div>
  );
};

export default GridContainer;